import { getUnixTime } from "date-fns/esm";
import { NetworkStatus } from "@apollo/client";

import useGetTimeToRecoveryRange from "shared/DoraMetrics/useGetTimeToRecoveryRange";

import useDoraDateRange from "../useDateRange";

const useDoraTimeToRecoveryRange = () => {
  const { startTime, endTime } = useDoraDateRange();

  const { range, hasRuns, loading, error, refetch, networkStatus } =
    useGetTimeToRecoveryRange({
      startTimeUnix: getUnixTime(startTime),
      endTimeUnix: getUnixTime(endTime),
    });

  const isLoading = (loading && !range) || networkStatus === NetworkStatus.refetch;

  return {
    range,
    hasRuns,
    isLoading,
    error,
    refetch,
  };
};

export default useDoraTimeToRecoveryRange;
